/**
 * Created by akrio on 2018/3/23.
 */
import {
  CURRENT_USER_INFO,
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_ID,
  CURRENT_PUBLISHER_SIMPLE,
  ADD_PUBLISHERS_STATES,
  FREE_MAX_AUTOPOST,
} from "../mutation-types";
import { User } from "../../services/users";

export default {
  state: {
    publisherStates: [], // 保存用户publisher状态
    publisherId: null, // 当前在active选中的publisher
    currentUserInfo: null, // 当前登录人信息
  },
  mutations: {
    [CURRENT_USER_INFO](state, currentUserInfo) {
      state.currentUserInfo = currentUserInfo;
    },
    [CURRENT_PUBLISHER_ID](state, publisherId) {
      console.log("publisherId", publisherId);
      state.publisherId = publisherId;
    },
    [ADD_PUBLISHERS_STATES](state, publisherStatus) {
      /**
       * 对象格式 {id:'publisher的id',status:'状态'}
       * status:
       *  none 普通状态
       *  success 激活成功状态
       *  limit 发送post被限制状态
       *  me 需要登录ins点击isme状态
       */
      // 如果传递 publisherStatus为空则清空
      if (publisherStatus === null) {
        state.publisherStates = [];
        return;
      }
      // 当发现状态变更为post成功时 弹出open apphi提示
      if (publisherStatus.status === "success") {
        // window.location.href = 'apphi-post://'
      }
      // 其他情况则说明publisherStates中有值，这时候需要判断是添加还是更新
      let publisher = state.publisherStates.find(
        (p) => p.id === publisherStatus.id
      );
      if (publisher) {
        /**
         * 如果是更新需要判断是原状态和现状态来看是否需要更新
         * 1.当原状态发现需要发送is me 但是新状态已经变成密码验证通过模式，则更新成"有密码(none)"模式
         * 2.当新状态为非none状态则直接覆盖新状态
         */
        const meToNoneStatus =
          publisher.status === "none" && publisherStatus.status === "me";
        const newStatusNotNone = publisher.status !== "none";
        if (
          (meToNoneStatus || newStatusNotNone) &&
          publisher.status !== publisherStatus.status
        ) {
          publisher.status = publisherStatus.status;
        }
      } else {
        state.publisherStates.push(publisherStatus);
      }
    },
  },
  getters: {
    [CURRENT_USER_INFO](state) {
      return state.currentUserInfo;
    },
    [CURRENT_PUBLISHER_ID](state) {
      // 如果存在选中publisher则传选中，如果没有选择则默认选第一个
      if (state.publisherId) {
        return state.publisherId;
      } else {
        try {
          return state.currentUserInfo.publiships[0].publisher.id;
        } catch (e) {
          return "";
        }
      }
    },
    [CURRENT_USER_INFO_SIMPLE](state) {
      if (state.currentUserInfo === null) {
        return null;
      }
      const user = new User(state.currentUserInfo);
      return user;
    },
    [CURRENT_PUBLISHER_SIMPLE](state) {
      // 如果存在publisherId则返回封装后的publisher用户
      const currentUser = new User(state.currentUserInfo);
      if (!state.currentUserInfo) {
        return null;
      }
      // 同时计算当前publisher的激活状态
      const currentPublisherStatus = state.publisherStates.find(
        (p) => p.id === state.publisherId
      );
      const activeStatus =
        currentPublisherStatus === undefined
          ? "none"
          : currentPublisherStatus.status;
      let currentPublisher = currentUser.linkedInstagramList.find(
        (l) => l.publisherId === state.publisherId
      );
      if (currentPublisher) {
        currentPublisher.activeStatus = activeStatus;
      }
      return currentPublisher;
    },
    [FREE_MAX_AUTOPOST](state) {
      // 获取free用户免费post数量
      if (state.currentUserInfo) {
        return Number(
          state.currentUserInfo.subscription.plan.default_autopost_count
        );
      } else {
        return 0;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js